// extracted by mini-css-extract-plugin
module.exports = {"fontDropdownContainer":"text-font-picker_fontDropdownContainer__s84Lf","button":"text-font-picker_button__fUxB9"};